import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Tag, ArrowRight } from "lucide-react";
import { api } from "../services/api";
import ProductCard from "../components/product/ProductCard";
import Reveal from "../components/Reveal";
import { Skeleton } from "../components/ui/skeleton";

export default function Nouveautes() {
  const [newArrivals, setNewArrivals] = useState([]);
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    Promise.all([
      api.get("/products?sort=newest&limit=8"),
      api.get("/products?on_sale=true&sort=newest&limit=8"),
    ])
      .then(([n, d]) => { setNewArrivals(n.data.products); setDeals(d.data.products); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div id="main" className="pt-32 pb-24 bg-white text-[#111111]">
      {/* Hero band */}
      <section className="container-queen">
        <Reveal className="relative overflow-hidden rounded-3xl px-8 sm:px-14 py-16 bg-[#111111] text-white">
          <p className="label-eyebrow text-[#C5A880] mb-3 flex items-center gap-2">
            <Sparkles size={14} /> Formulations Nouvelles
          </p>
          <h1 className="font-display text-white text-4xl sm:text-6xl leading-tight">
            Nouveautés &amp; <span className="italic font-light text-[#EAE8E4]">Éditions Spéciales</span>
          </h1>
          <p className="text-[#AAAAAA] mt-4 max-w-xl text-base font-body leading-relaxed">
            Les dernières innovations dermatologiques de la maison The Queen, accompagnées de nos coffrets duos exclusifs.
          </p>
        </Reveal>
      </section>

      {/* Best deals / Coffrets */}
      <section className="container-queen pt-20">
        <Reveal className="flex items-end justify-between mb-10">
          <div>
            <p className="label-eyebrow text-[#C5A880] mb-2 flex items-center gap-2">
              <Tag size={14} /> Privilèges &amp; Coffrets
            </p>
            <h2 className="font-display text-3xl sm:text-4xl text-[#111111]">Offres Rituels</h2>
          </div>
          <Link to="/shop" className="btn-queen-ghost hidden sm:flex">
            Tous les soins <ArrowRight size={16} />
          </Link>
        </Reveal>
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="w-full rounded-2xl aspect-[4/5]" />)}
          </div>
        ) : deals.length === 0 ? (
          <p className="text-[#666666]">Aucune offre spéciale pour le moment.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {deals.map((p, i) => <Reveal key={p.id} delay={i * 60}><ProductCard product={p} /></Reveal>)}
          </div>
        )}
      </section>

      {/* New arrivals */}
      <section className="container-queen pt-24">
        <Reveal className="flex items-end justify-between mb-10">
          <div>
            <p className="label-eyebrow text-[#C5A880] mb-2 flex items-center gap-2">
              <Sparkles size={14} /> Catalogue Complet
            </p>
            <h2 className="font-display text-3xl sm:text-4xl text-[#111111]">Tous nos Soins</h2>
          </div>
        </Reveal>
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="w-full rounded-2xl aspect-[4/5]" />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {newArrivals.map((p, i) => <Reveal key={p.id} delay={i * 60}><ProductCard product={p} /></Reveal>)}
          </div>
        )}

        <div className="text-center mt-16">
          <Link to="/shop" className="btn-queen-secondary">Explorer la collection complète</Link>
        </div>
      </section>
    </div>
  );
}
